import { css } from 'linaria';
import { breakpoints } from '../../../media';

export const questionsAccordionStyles = css`
	display: flex;
	flex-direction: column;
	margin-top: 24px;
	border: 1px solid #e8e9eb;
	border-radius: 8px;
	${breakpoints.from.desktop} {
		max-width: 878px;
	}
	${breakpoints.to.desktop} {
		margin-top: 24px;
	}
`;
